import { configSUSTAINABLE } from '../src/aca-config-SUSTAINABLE';
export const acaConfig = configSUSTAINABLE;
